import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { ButtonBase, InputBase } from "../../../common/components/form";
import * as API from "../../lib/api.js";
import * as Links from "../../lib/links.js";
import { setShowUnauthorized } from "../../store/panel.js";
import AutorizationTopBar from "../Authorization/AutorizationTopBar.jsx";
import MessageContinue from "../MessageContinue";
import Wait from "../Wait";

export default function Restoring() {
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();

    const [wait, setWait] = React.useState(false);
    const [complete, setComplete] = React.useState(false);
    const [end, setEnd] = React.useState(false);
    const [email, setEmail] = React.useState("");
    const [errors, setErrors] = React.useState({});

    React.useEffect(() => {
        dispatch(setShowUnauthorized(false));
        scroll({ top: 0, behavior: "smooth" });
    }, []);

    function onChange({ target: { value } }) {
        setEmail(value);
    }

    function onBackClick() {
        history.push(Links.Login());
    }

    function onRestoreClick() {
        setWait(true);
        API.Send("/account/recovery", { email })
            .then(res => {
                if (!res?.ok) {
                    toast.error(t("RESTORING_ACCOUNT_NOT_FOUND"));
                    return;
                }

                toast.success(t("RESTORING_ACCOUNT_SUCCESS"));
                history.push(Links.Login());
                setComplete(true);
            })
            .finally(() => setWait(false));
    }

    function onContinueClick() {
        setEnd(true);
        history.push(Links.Login());
    }

    function errorByField(fieldname) {
        return errors[fieldname] ? t(errors[fieldname]) : null;
    }

    const allowNext = email && /^[^@]+\@[^@\.]+(\.[^\@\.]+)+$/.test(email);

    return (
        <>
            <div className="auth-bg-blur" />

            <div className="panel-login">
                <MessageContinue show={complete} end={end} onContinue={onContinueClick}>
                    {t("RestorePasswordMail")}
                </MessageContinue>

                <AutorizationTopBar />

                <form action="#" onSubmit={e => e.preventDefault()}>
                    <div className="panel-login-fields">
                        <h1>{t("RestoringAccess")}</h1>

                        <div className="margin-top-20">
                            <div>
                                <InputBase
                                    name="email"
                                    onChange={onChange}
                                    value={email || ""}
                                    placeholder={t("Email")}
                                    error={errorByField("email") || ""}
                                    fullWidth
                                    small
                                />
                            </div>
                        </div>

                        <div className="panel-login-buttons">
                            <ButtonBase solid type="submit" onClick={onBackClick}>
                                {t("Back")}
                            </ButtonBase>

                            <ButtonBase invert type="submit" onClick={onRestoreClick} disabled={!allowNext}>
                                {t("RestoreAccess")}
                            </ButtonBase>
                        </div>
                    </div>
                </form>
            </div>

            <Wait show={wait} />
        </>
    );
}
